/**
 * Pictures with no signal (unit 25C7, Q2): the Service Worker keeps each one
 * the person has seen, as it keeps the map's tiles. A picture is served by its
 * id and never changes (`Cache-Control: immutable`), so the cached copy is
 * always right. Pictures are not fetched ahead; if a first trip offline shows
 * empty frames, that is the time to (Q2's (b)).
 *
 * They are one person's, like the rows: another person signing in drops them
 * with the cache (rule 7).
 */

export const IMAGE_CACHE = "kindred-images-v1";
export const IMAGE_PATH = "/api/images/";

/** Drop every kept picture. Nothing to do where there is no Cache Storage. */
export async function dropImages(): Promise<void> {
  if (typeof caches === "undefined") return;
  await caches.delete(IMAGE_CACHE);
}
